// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.emd-avatar {\n  margin-left: auto;\n  margin-right: 0;\n}\n.emd-user-menu__popup-item a svg {\n  width: 20px;\n}\n.emd-user-menu._open .emd-user-menu__popup {\n  width: auto;\n  height: auto;\n  min-height: 0;\n}\n/* @media (max-width: 767px) {\n  .emd-user-menu._open .emd-user-menu__popup {\n    min-height: calc(100vh - 76px);\n  }\n  .emd-user-menu .emd-user-menu__popup {\n    right: -18px;\n  }\n} */\n", ""]);
// Exports
module.exports = exports;
